import React from 'react'
import { motion } from 'framer-motion'
import { CloudOff, Wifi } from 'lucide-react'
import { usePWA } from '../../contexts/PWAContext'

export const OfflineIndicator: React.FC = () => {
  const { isOnline, connectionSpeed } = usePWA()

  if (isOnline && connectionSpeed !== 'slow') return null

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="sticky top-0 z-50 bg-gradient-to-r from-red-500 to-red-600 text-white p-2 text-center text-sm"
    >
      <div className="flex items-center justify-center gap-2">
        {!isOnline ? (
          <>
            <CloudOff className="h-4 w-4" />
            <span>You're offline - Cached content available</span>
          </>
        ) : (
          <>
            <Wifi className="h-4 w-4 opacity-50" />
            <span>Slow connection - Some features may be limited</span>
          </>
        )}
      </div>
    </motion.div>
  )
}

export const OfflineBanner: React.FC = () => {
  const { isOnline } = usePWA()

  if (isOnline) return null

  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <CloudOff className="h-5 w-5 text-yellow-400" />
        </div>
        <div className="ml-3">
          <p className="text-sm text-yellow-700">
            <strong>Offline Mode:</strong> You can continue chatting with cached responses. 
            New responses will sync when you're back online.
          </p>
        </div>
      </div>
    </div>
  )
}